// src/components/games/GameInfoBox.js
import React, { useState, useRef, useEffect } from "react";

function GameInfoBox({
  capsuleImage,
  description,
  releaseDate,
  genre,
  developer,
  publisher,
  rating,
}) {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const descRef = useRef(null);

  useEffect(() => {
    const el = descRef.current;
    if (el) {
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const maxLines = 3;
      const maxHeight = lineHeight * maxLines;
      setIsOverflowing(el.scrollHeight > maxHeight);
    }
  }, [description]);

  return (
    <div className="bg-neutral-800 p-5 rounded text-white text-sm space-y-3">
      <h3 className="text-lg font-bold">게임 정보</h3>

      <div className="w-full aspect-[16/7] bg-gray-700 rounded overflow-hidden">
        <img
          src={capsuleImage}
          alt="게임 캡슐 이미지"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative">
        <div
          ref={descRef}
          className={`text-gray-300 text-sm leading-relaxed transition-all duration-300 overflow-hidden ${
            expanded ? "max-h-[1000px]" : "max-h-[4.5rem]"
          }`}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: expanded ? "unset" : 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {description}
        </div>

        {isOverflowing && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="block text-right w-full text-xs mt-1 text-gray-400 hover:underline"
          >
            {expanded ? "간략히 보기 ▲" : "더보기 ▼"}
          </button>
        )}
      </div>

      {/* 테이블에서 행 간격을 주기 위해 border-separate + border-spacing-y-3 사용 */}
      <table className="w-full table-fixed border-separate border-spacing-y-3 mt-4 ml-2 text-sm">
        <tbody>
          <tr>
            <th className="w-24 text-gray-400 pr-6 text-left align-top">출시일</th>
            <td className="text-gray-300"> {releaseDate} </td>
          </tr>
          <tr>
            <th className="w-24 text-gray-400 pr-6 text-left align-top">장르</th>
            <td className="text-gray-300"> {genre} </td>
          </tr>
          <tr>
            <th className="w-24 text-gray-400 pr-6 text-left align-top">창작자</th>
            <td className="text-gray-300"> {developer} </td>
          </tr>
          <tr>
            <th className="w-24 text-gray-400 pr-6 text-left align-top">배급사</th>
            <td className="text-gray-300"> {publisher} </td>
          </tr>
          <tr>
            <th className="w-24 text-gray-400 pr-4 text-left align-top">이용등급</th>
            <td className="text-gray-300"> {rating} </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default GameInfoBox;
